import type { TimeSeriesChartWidget } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../../../components/generic/Modal';
import { TimeSeriesWidgetModalContent } from './TimeSeriesWidgetModalContent';

interface Props {
  participantId: string;
  widget: TimeSeriesChartWidget;
  onEdit: (item: TimeSeriesChartWidget) => void;
}

export const TimeSeriesWidgetEditModal = createModal<Props>((props) => {
  const { modal, participantId, widget, onEdit } = props;

  const { visible, hide, remove } = modal;

  const onSubmit = (widget: TimeSeriesChartWidget) => {
    onEdit(widget);
    hide();
  };

  return (
    <ChakraV3.Dialog.Root
      open={visible}
      onOpenChange={hide}
      onExitComplete={remove}
      size='cover'
      scrollBehavior='inside'
    >
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.Dialog.Body p={2}>
            <TimeSeriesWidgetModalContent
              participantId={participantId}
              onSubmit={onSubmit}
              widget={widget}
            />
          </ChakraV3.Dialog.Body>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
